/**
 * @returns undefined
 */
export function noop() {
    /**
     * DO NOT PROCEED ⛔️ ☠
     * this function contains very critical application logic
     * for proper functioning of features and whole platform
     * any change here migth break the overall application
    *
     * Untll and unless you have complete understanding what you are doing here
     * or if you think you might have wandered here by mistake,
     * return back!
     *  Any changes done here should be verified and reviewed properly by TLs and Managers before being pushed to production
     * */
}
